import React, { useState, memo } from "react";
import { Tooltip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import moment from "moment-jalaali";
import Api from "../../utils/api";
import { Loading } from "../../components";
import { useSelector } from "react-redux";
import ExcelJS from "exceljs";

const ExcelDownload = ({ object, ids }) => {
    const AppState = useSelector(state => state);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        let params = { ...object, excel_export: 1 };
        if (ids.length > 0) {
            params.ids = ids.join(',');
        }

        try {
            const response = await new Api().get('/orders', params);
            if (response) {
                const data = response.map(item => ({
                    'شماره سفارش': item.id,
                    'شناسه کاربر': item.user ? item.user.id : '',
                    'کاربر': item.user ? `${item.user.name} ${item.user.family}` : '-',
                    'موبایل': item.user ? item.user.mobile : '-',
                    'قیمت واقعی': item.price,
                    'قیمت با تخفیف': item.off_price,
                    'خرده فروشی': item.retail_reward,
                    'هزینه پستی': item.post_cost,
                    'تخفیف': item.discount,
                    'مالیات': item.tax,
                    'قیمت کل': item.total_pay,
                    'وضعیت': AppState.orders.status?.[item.status] || '',
                    'پرداخت': AppState.orders.paid?.[item.paid] || '',
                    'فاکتور خصوصی': AppState.orders.private?.[item.private] || '',
                    'مرجوعی': AppState.orders.returned?.[item.returned] || '',
                    'درگاه': item.transaction ? AppState.transaction.gateway?.[item.transaction.gateway] || '' : '',
                    'شهر': item.address?.region_title || '',
                    'تاریخ': moment(item.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')
                }));

                await exportToExcel(data);
            }
        } catch (error) {
            console.error("خطا در دریافت داده‌ها:", error);
        } finally {
            setLoading(false);
        }
    };

    const exportToExcel = async (data) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("سفارشات");

        worksheet.columns = Object.keys(data[0]).map((key) => ({
            header: key,
            key: key,
            width: 20,
        }));

        data.forEach((item) => {
            worksheet.addRow(item);
        });

        const buffer = await workbook.xlsx.writeBuffer();

        const blob = new Blob([buffer], {
            type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = `orders_${Date.now()}.xlsx`;
        document.body.appendChild(anchor);
        anchor.click();

        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
    };

    return (
        <>
            <Tooltip title="خروجی اکسل">
                {loading && <Loading />}
                <IconButton onClick={fetchData} disabled={loading}>
                    <ImportExportIcon />
                </IconButton>
            </Tooltip>

            <Dialog
                fullWidth
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="dialog-title"
            >
                <DialogTitle id="dialog-title">در حال پردازش...</DialogTitle>
                <DialogContent>
                    {loading && <Loading />}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary">
                        بستن
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default memo(ExcelDownload);
